module.exports = "<listado-general \r\n  [listado]=\"channels\" \r\n  [titulo]=\"'CHANNELS' | translate\"\r\n  [urladicional]=\"''\"\r\n  (clickNuevo)=\"navegarNuevoChannel()\"\r\n  [ocultarNuevo]=\"ocultarNuevo\"\r\n  [clickBack]=\"true\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/channels/listado.channels.component.html
// module id = ../../../../../src/app/private/channels/listado.channels.component.html
// module chunks = main